export const attributeMigrations = [
		{
			source: 'HS_HousingShape',
			migrations: [
				{
					target: 'root::Heads::Head::Housing::HS_HousingShape',
					valueMapping: null
				}
			]
		},
		{
			source: 'HS_HousingPowerConnection',
			migrations: [
				{
					target: 'root::Heads::Head::Housing::HS_HousingPowerConnection',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_HousingColour',
			migrations: [
				{
					target: 'root::Heads::Head::ColourCoatingBase::HS_HousingColour',
					valueMapping: null
				}
			]
		},
		{
			source: 'HS_HousingCoating',
			migrations: [
				{
					target: 'root::Heads::Head::ColourCoatingBase::HS_HousingCoating',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_ColourPriceCategory',
			migrations: [
				{
					target: 'ColourCoating::HS_ColourPriceCategory',
					valueMapping: null
				}
			],
		},
		{
			source: 'CX_Region',
			migrations: [
				{
					target: 'shared::ContextV3::CX_Region',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_LightEmission',
			migrations: [
				{
					target: 'shared::PreFilter::LU_Filter_LightEmission_Uplight',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_LightEmissionCAFilter',
			migrations: [
				{
					target: 'shared::PreFilter::LU_Filter_LightEmission_CA',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_ConstantLumenTechnology_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_Control_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::EB_Control',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_EBlockMountingType_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::EB_EBlockMountingType',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_ElectricalProtectionClass_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_Wattage_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::EB_Wattage',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_HousingPowerConnectionPosition_1',
			migrations: [
				{
					target: 'root::Heads::Head::EBlock::HS_HousingPowerConnectionPosition',
					valueMapping: null
				}
			],
		},
		{
			source: 'EB_ConstantLumenTechnology_2',
			migrations: [{
				target: 'root::Heads::Head_2::EBlock::EB_ConstantLumenTechnology',
				valueMapping: null
			}],
		},
		{
			source: 'EB_Control_2',
			migrations: [{
				target: 'root::Heads::Head_2::EBlock::EB_Control',
				valueMapping: null
			}],
		},
		{
			source: 'EB_EBlockMountingType_2',
			migrations: [{
				target: 'root::Heads::Head_2::EBlock::EB_EBlockMountingType',
				valueMapping: null
			}],
		},
		{
			source: 'EB_ElectricalProtectionClass_2',
			migrations: [{
				target: 'root::Heads::Head_2::EBlock::EB_ElectricalProtectionClass',
				valueMapping: null
			}],
		},
		{
			source: 'EB_Wattage_2',
			migrations: [{
				target: 'root::EBlock_2::EB_Wattage',
				valueMapping: null
			}],
		},
		{
			source: 'HS_HousingPowerConnectionPosition_2',
			migrations: [{
				target: 'root::Heads::Head_2::EBlock::HS_HousingPowerConnectionPosition',
				valueMapping: null
			}],
		},
		{
			source: 'LE_ColourTemperature_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
				valueMapping: null
			}],
		},
		{
			source: 'LE_DimmingLevel_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightDistribution_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightEmissionCA_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA',
				valueMapping: null
			}],
		},
		{
			source: 'LE_Uplight_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightEngineModuleSize_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
				valueMapping: [
					{
						source: 'M1Single',
						target: 'M1'
					},
					{
						source: 'M1',
						target: 'M1'
					},
					{
						source: 'M3',
						target: 'M3'
					},
					{
						source: 'M6',
						target: 'M6'
					},
					{
						source: 'M12',
						target: 'M12'
					},
					{
						source: '6xM1',
						target: '6xM1'
					},
					{
						source: '12xM1',
						target: '12xM1'
					}
				]
			}],
		},
		{
			source: 'LE_LuminousFlux_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_LuminousFlux',
				valueMapping: null
			}],
		},
		{
			source: 'LE_OpticalVersion_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
				valueMapping: null
			}],
		},
		{
			source: 'LE_ReflectorColour_1',
			migrations: [{
				target: 'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
				valueMapping: null
			}],
		},
		{
			source: 'LE_ColourTemperature_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ColourTemperature',
				valueMapping: null
			}],
		},
		{
			source: 'LE_DimmingLevel_2',
			migrations: [{
				target: 'root::LightEngine_2::LE_DimmingLevel',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightDistribution_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightDistribution',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightEmissionCA_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_CA',
				valueMapping: null
			}],
		},
		{
			source: 'LE_Uplight_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
				valueMapping: null
			}],
		},
		{
			source: 'LE_LightEngineModuleSize_2',
			migrations: [{
				target: 'root::LightEngine_2::LE_LightEngineModuleSize',
				valueMapping: [
					{
						source: 'M1Single',
						target: 'M1'
					},
					{
						source: 'M1',
						target: 'M1'
					},
					{
						source: 'M3',
						target: 'M3'
					},
					{
						source: 'M6',
						target: 'M6'
					},
					{
						source: 'M12',
						target: 'M12'
					},
					{
						source: '6xM1',
						target: '6xM1'
					},
					{
						source: '12xM1',
						target: '12xM1'
					}
				]
			}],
		},
		{
			source: 'LE_LuminousFlux_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_LuminousFlux',
				valueMapping: null
			}],
		},
		{
			source: 'LE_OpticalVersion_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_OpticalVersion',
				valueMapping: null
			}],
		},
		{
			source: 'LE_ReflectorColour_2',
			migrations: [{
				target: 'root::Heads::Head_2::Type::Luminaire::LightEngine::LE_ReflectorColour',
				valueMapping: null
			}],
		},
		{
			source: 'HS_NumberPoleDoors',
			migrations: [{
				target: 'root::Poles::Pole::Basic::HS_NumberPoleDoors',
				valueMapping: null
			}],
		},
		{
			source: 'HS_Construction',
			migrations: [{
				target: 'root::Poles::Pole::SpecialLine::HS_Construction',
				valueMapping: null
			}],
		},
		{
			source: 'HS_HousingMountingLocationEblock_1',
			migrations: [
				{
					target: 'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock_1',
					valueMapping: null
				},
				{
					target: 'root::Heads::Head::EBlock::EB_EBlockMountingType',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_HousingMountingLocationEBlock_2',
			migrations: [
				{
					target: 'root::Poles::Pole::SpecialLine::HS_HousingMountingLocationEBlock_2',
					valueMapping: null
				},
				{
					target: 'root::Heads::Head_2::EBlock::EB_EBlockMountingType',
					valueMapping: null
				}
			],
		},
		{
			source: 'HS_HousingType',
			migrations: [{
				target: 'shared::ProductType::HS_HousingType',
				valueMapping: null
			}],
		},
		{
			source: 'HS_HousingZhaga',
			migrations: [{
				target: 'root::Heads::Head::SmartControl::HS_HousingZhaga',
				valueMapping: null
			}],
		},

		{
			source: 'HS_Base',
			migrations: [
				{
					target: 'root::Heads::Head::Housing::HS_HousingConnection',
					valueMapping: [
						{
							source: 'PoleTopAdapter60mm',
							target: 'PoleTopAdapter60mm'
						},
						{
							source: 'PoleTopAdapter76mm',
							target: 'PoleTopAdapter76mm'
						}
					]
				},
				{
					target: 'root::Poles::Pole::Basic::HS_Base',
					valueMapping: [
						{
							source: 'BuriedBase',
							target: 'BuriedBase'
						},
						{
							source: 'BuriedBaseShort',
							target: 'BuriedBaseShort'
						},
						{
							source: 'FlangePlateFRSmall',
							target: 'FlangePlateFRSmall'
						},
						{
							source: 'FlangePlateFR',
							target: 'FlangePlateFR'
						},
						{
							source: 'BollardGrounding',
							target: 'BollardGrounding'
						},
						{
							source: 'FlangePlateDE',
							target: 'FlangePlateDE'
						}
					]
				}
			],
		},

		{
			source: 'HS_HousingHeight',
			migrations: [
				{
					target: 'shared::HousingLuminaire::HS_HousingHeight',
					valueMapping: [
						{
							source: 'A2',
							target: 'A2'
						},
						{
							source: 'A4',
							target: 'A4'
						},
						{
							source: 'A6',
							target: 'A6'
						},
						{
							source: 'A8',
							target: 'A8'
						},
						{
							source: 'B2',
							target: 'B2'
						},
						{
							source: 'B4',
							target: 'B4'
						},
						{
							source: 'B6',
							target: 'B6'
						},
						{
							source: 'B8',
							target: 'B8'
						},
					]
				},

				{
					target: 'root::Poles::Pole::Basic::HS_Height',
					valueMapping: [
						{
							source: '06',
							target: '600'
						},
						{
							source: '08',
							target: '800'
						},
						{
							source: '10',
							target: '1000'
						},
						{
							source: '12',
							target: '1200'
						},
						{
							source: '30',
							target: '3000'
						},
						{
							source: '40',
							target: '4000'
						},
						{
							source: '50',
							target: '5000'
						},
						{
							source: '60',
							target: '6000'
						},
						{
							source: '70',
							target: '7000'
						},
					]
				}
			]
		}

	]
;

